import React from 'react';
import { Typography } from '@statsbomb/kitbag-components';
import { FormattedMessage } from 'react-intl';

export function Home() {
  return (
    <Typography variant="headingLarge">
      <FormattedMessage
        defaultMessage="Welcome to the Video App"
        id="40ccd"
        description="Welcome message"
      />
    </Typography>
  );
}

export default { Home };
